import CustomsInfo from "./CustomsInfo";
export default CustomsInfo;
